import $i18n from 'panda-i18n';

const RETURN_REASON = [
  {
    label: $i18n.get({ id: 'NoReasonForReturn', dm: '(无退件原因)' }),
    value: '',
  },
  {
    label: 'Too Big',
    value: '1',
  },
  {
    label: 'Too Small',
    value: '2',
  },
  {
    label: 'Ordered the wrong item',
    value: '3',
  },
  {
    label: 'Unwanted / Changed my mind',
    value: '4',
  },
  {
    label: 'Wrong item shipped',
    value: '5',
  },
  {
    label: 'Item not as described / Pictured ',
    value: '6',
  },
  {
    label: 'Defective / Damaged / Poor Quality',
    value: '7',
  },
];
export const PATTERN = [
  {
    label: $i18n.get({ id: 'AECentralWarehouse', dm: 'AE中心仓' }),
    value: 'AE_CENTER',
  },
  {
    label: $i18n.get({ id: 'AELocalReturnWarehouse', dm: 'AE本地退货仓' }),
    value: 'AE_LOCAL',
  },
];

export { RETURN_REASON };
